import DGLTH_gyv_mpm from '../components/DGLTH/DGLTH_gyv_mpm';
import DGLTH_shipping_plan from '../components/DGLTH/DGLTH_shipping_plan';
import DGLTH_supplier_order from '../components/DGLTH/DGLTH_supplier_order';
import DGLTH_customer_order from '../components/DGLTH/DGLTH_customer_order';
import DGLTH_customer_offer from '../components/DGLTH/DGLTH_customer_offer';
import DGLTH_customer_invoices from '../components/DGLTH/DGLTH_customer_invoices';
import DGLTH_item_model from '../components/DGLTH/DGLTH_item_model';
import DGLTH_item_model_open_row from '../components/DGLTH/DGLTH_item_model_open_row';
import DGLTH_pdc_item_model from '../components/DGLTH/DGLTH_pdc_item_model';
import DGLTH_order_list from '../components/DGLTH/DGLTH_order_list';
import DGLTH_open_customer_rows_badge from '../components/DGLTH/DGLTH_open_customer_rows_badge';
import DGLTH_open_customer_rows_distinta from '../components/DGLTH/DGLTH_open_customer_rows_distinta';
import DGLTH_pdc_badge from '../components/DGLTH/DGLTH_pdc_badge';
import DGLTH_pdc_distinta from '../components/DGLTH/DGLTH_pdc_distinta';
import DGLTH_stocks_button from '../components/DGLTH/DGLTH_stocks_button';
import DGLTH_item_model_quantity from '../components/DGLTH/DGLTH_item_model_quantity';
import DGLTH_ddt_supplier from '../components/DGLTH/DGLTH_ddt_supplier';
import DGLTH_db_query from '../components/DGLTH/DGLTH_db_query';
import DGLTH_customer_transport_document from '../components/DGLTH/DGLTH_customer_transport_document';
import DGLTH_customer_ddt from '../components/DGLTH/DGLTH_customer_ddt';
import DGLTH_order_list_request from '../components/DGLTH/DGLTH_order_list_request';
import DGLTH_supplier_invoices_received from '../components/DGLTH/DGLTH_supplier_invoices_received';



export default function DataGridLastTdHook({ item, props, entity = null, data, setData, refreshData }) {

    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'sample': return (
                            <span>Test</span>
                        );
                        case 'item_model': return (
                            <DGLTH_item_model item={item} entity={entity} />
                        );
                        case 'gyv_mpm': return (
                            <DGLTH_gyv_mpm item={item} entity={entity} />
                        );
                        case 'shipping_plan': return (
                            <DGLTH_shipping_plan item={item} entity={entity} refreshData={refreshData} />
                        );
                        case 'supplier_order': return (
                            <DGLTH_supplier_order item={item} entity={entity} refreshData={refreshData} />
                        );
                        case 'customer_order': return (
                            <DGLTH_customer_order item={item} entity={entity} />
                        );
                        case 'customer_offer': return (
                            <DGLTH_customer_offer item={item} entity={entity} refreshData={refreshData} />
                        );
                        case 'gyv_mrp_order_list': return (
                            <DGLTH_order_list item={item} entity={entity} data={data} setData={setData} />
                        );
                        case 'gyt_order_list_request': return (
                            <DGLTH_order_list_request item={item} entity={entity} />
                        );
                        case 'gyv_open_customer_rows': return (
                            <>
                                <div className='d-flex flex-row gap-1 align-items-center'>
                                    <DGLTH_open_customer_rows_badge item={item} entity={entity} />
                                    <DGLTH_open_customer_rows_distinta item={item} entity={entity} />
                                    <DGLTH_item_model_open_row item={item} entity={entity} refreshData={refreshData}/>
                                </div>
                            </>
                        );
                        case 'gyv_pdc': return (
                            <>
                                <div className='d-flex flex-row gap-1 align-items-center'>
                                    <DGLTH_pdc_badge item={item} entity={entity} />
                                    <DGLTH_pdc_distinta item={item} entity={entity} />
                                    <DGLTH_pdc_item_model item={item} entity={entity} refreshData={refreshData}/>
                                </div>
                            </>
                        );
                        case 'gyv_stocks': return (
                            <DGLTH_stocks_button item={item} entity={entity} />
                        );
                        case 'supplier_transport_document': return (
                            <DGLTH_ddt_supplier item={item} entity={entity} refreshData={refreshData} />
                        );
                        case 'db_query': return (
                            <DGLTH_db_query item={item} entity={entity} />
                        );
                        case 'gyv_customer_transport_document': return (
                            <DGLTH_customer_transport_document item={item} entity={entity} refreshData={refreshData} />
                        );
                        case 'customer_invoices': return (
                            <DGLTH_customer_invoices item={item} entity={entity} data={data} setData={setData} refreshData={refreshData} />
                        );
                        case 'customer_ddt': return (
                            <DGLTH_customer_ddt item={item} entity={entity} refreshData={refreshData} />
                        );
                        case 'item_model_quantity': return (
                            <DGLTH_item_model_quantity item={item} entity={entity} refreshData={refreshData} />
                        );
                        case 'supplier_invoices_received': return (
                            <DGLTH_supplier_invoices_received item={item} entity={entity} refreshData={refreshData} />
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
}
